import { useEffect, useRef, useState } from 'react';
import { fetchCloudThumbnailBlobUrl } from '@/lib/cloudApi';

/**
 * Renders a cloud doc's page-1 thumbnail, falling back to the caller's
 * placeholder (e.g. the FileText icon) when no thumbnail is stored or the
 * fetch fails. The thumbnail image is fetched authed, turned into a blob
 * URL, and revoked on unmount.
 */
export default function CloudThumbnail({ docId, hasThumbnail, className, alt, placeholder }) {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const urlRef = useRef(null);

  useEffect(() => {
    if (!hasThumbnail || !docId) return undefined;
    let cancelled = false;
    fetchCloudThumbnailBlobUrl(docId)
      .then((blobUrl) => {
        if (cancelled) {
          if (blobUrl) URL.revokeObjectURL(blobUrl);
          return;
        }
        if (!blobUrl) { setFailed(true); return; }
        urlRef.current = blobUrl;
        setUrl(blobUrl);
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => {
      cancelled = true;
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current);
        urlRef.current = null;
      }
    };
  }, [docId, hasThumbnail]);

  if (!hasThumbnail || failed || !url) return placeholder;
  return <img src={url} alt={alt || ''} className={className} loading="lazy" />;
}
